import React from 'react';
import image404 from '../../assets/img/page_404.png';
import styles from './styles.module.scss';

export const NotFound = () => {
    return (
        <div className={styles.container}>
            <img src={image404} alt="página 404" />

            <span> Página não encontrada! </span>
        </div>
    );
};
